import React, { FC } from 'react'

import { FeesRow } from './FeesRow'

import { IFeesTab } from '../../../../../models/event-registered-users/event-registered-users.interface'
import { IRegistrationFeesInterface } from '../../../../../models/registration-fees/registrationFees.interface'

interface FeesItemProps {
  feesCategory: string
  feesTabData: IFeesTab[]
  loading: boolean
  setLoading: (state: boolean) => void
  currency: string
  soldFeesById: { [key: string]: IRegistrationFeesInterface[] }
}

const FeesItem: FC<FeesItemProps> = ({
  feesTabData,
  feesCategory,
  loading,
  setLoading,
  currency,
  soldFeesById,
}) => {
  const filteredFeesTabData = feesTabData.filter((fees) => fees.feesCategory === feesCategory)

  return filteredFeesTabData?.[0] ? (
    <div className="border border-black/10 rounded-xl p-4 sm:p-6">
      <div className="capitalize font-medium text-[20px]">
        {filteredFeesTabData[0].feesCategory === 'governance'
          ? 'Mandatory'
          : filteredFeesTabData[0].feesCategory}
      </div>
      {filteredFeesTabData.map((item, index) => (
        <FeesRow
          key={index}
          item={item}
          loading={loading}
          setLoading={setLoading}
          currency={currency}
          available={item.available - (soldFeesById[item.feesItemId]?.length || 0)}
        />
      ))}
    </div>
  ) : null
}

export default FeesItem
